import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';

import '@/css/desktop/search';
import '@/css/desktop/search/destination-info-atlas.css';

import AbstractSearchController from '@/js/desktop/Domain/Abstract/SearchController';

$(() => {
    const searchController = new AbstractSearchController({
        el: 'body',
    });

    searchController.initSearchOnScroll();
});
